<template>
  <div>
    <BackButton class="u-margin-bottom-small"></BackButton>
    <CreateQuestionForm @submit="createQuestion($event)" :loadingSave="loadingSave"></CreateQuestionForm>
  </div>
</template>

<script>
import CreateQuestionForm from '@/pages/Questions/CreateQuestionForm';
import BackButton from '@/components/buttons/BackButton';
import DashboardElementController from '@/controllers/DashboardElement/DashboardElementController';
import QuestionController from '@/controllers/Question/QuestionController';
import ApproveQuestionController from '@/controllers/Question/ApproveQuestionController';
import QuestionConsumptionCategoryController from '@/controllers/Question/QuestionConsumptionCategoryController';
import SendQuestionNotificationController from '@/controllers/Question/SendQuestionNotificationController';
export default {
  name: 'CreateQuestion',
  components: { BackButton, CreateQuestionForm },
  data() {
    return {
      loadingSave: false,
    };
  },
  methods: {
    async createQuestion(event) {
      this.loadingSave = true;
      try {
        if (event.dashForm.headline) {
          let dashElement = await DashboardElementController.store(event.dashForm);
          event.form.dashboard_element_id = dashElement.id;
        }
        let question = await QuestionController.store(event.form);

        if (event.form.consumption_category_ids.length > 0) {
          await QuestionConsumptionCategoryController.store({
            question_id: question.id,
            consumption_category_ids: event.form.consumption_category_ids,
          });
        } else {
          await QuestionConsumptionCategoryController.destroy(question.id);
        }

        if (event.form.approved) await ApproveQuestionController.update(question.id);
        if (event.notify_users === true) await SendQuestionNotificationController.store(question.id);
        await this.$router.push({ name: 'Manage Questions' });
        this.$notify({
          type: 'success',
          title: 'Successfully created!',
        });
      } catch (error) {
        Object.entries(error.response.data).forEach((item) => {
          this.$notify({
            type: 'danger',
            title: item[1],
          });
        });
      }
      this.loadingSave = false;
    },
  },
};
</script>

<style scoped></style>
